import axios from "axios";
const baseUrl = "/api/v1/users";
const config = {
  headers: {
    "Content-Type": `application/x-www-form-urlencoded`,
  },
};

// This file specifically will be for form password change HTTP request
export const forgotPassword = {
  reqPass: ({ email, pageUrl }) =>
    axios.post(
      `${baseUrl}/request-passreset?email=${email}&pageUrl=${pageUrl}`,
      {},
      config
    ),
  changePass: (id, payload) =>
    axios.put(`${baseUrl}/do-passreset?helperId=${id}`, payload),
};
